<button type="button" cypressTag="General.Info" [tippy]="description" [tippyPlacement]="tooltipPosition">
	<fa-icon icon="fa-solid fa-circle-question" />
</button>
